import Box from '@mui/material/Box';
import React, { useState } from 'react';
import { CLOSED, DRAFT, PUBLISHED, REOPEN, UPDATE_SURVEY } from '../../constants';
import { ExportModal } from '../ExportModal/ExportModal';
import Button from '../FormComponents/Button';
import './SurveyForm.scss';

interface Actions {
  surveyId: string;
  type: string;
  status: string;
  loading: boolean;
  cloneLoading: boolean;
  isSameData: boolean;
  saveAsDraft: () => void;
  handleClone: () => void;
  handlePublishClick: () => void;
  setConfirmationType: (type: string) => void;
  setConfirmationPopupText: (text: string) => void;
}

const Actions = React.memo((props: Actions) => {
  const {
    surveyId,
    type,
    status,
    loading,
    cloneLoading,
    isSameData,
    saveAsDraft,
    handleClone,
    handlePublishClick,
    setConfirmationType,
    setConfirmationPopupText,
  } = props;

  const [showExportPopup, setShowExportPopup] = useState(false);

  return (
    <Box className='submit-button'>
      <Button
        text='Export as PDF'
        onClick={() => setShowExportPopup(!showExportPopup)}
        disabled={!surveyId}
        variant='outlined'
      />
      <ExportModal
        showExportPopup={showExportPopup}
        setShowExportPopup={setShowExportPopup}
        organizationId={null}
        surveyId={surveyId}
      />
      {![CLOSED, PUBLISHED].includes(status) && <Button text='Save as draft' onClick={saveAsDraft} loading={loading} />}
      {type === UPDATE_SURVEY && status === PUBLISHED && (
        <Button
          text='Close'
          onClick={() => {
            setConfirmationType(CLOSED);
            setConfirmationPopupText('Are you sure you want to close this survey for submissions?');
          }}
          color='error'
        />
      )}
      {type === UPDATE_SURVEY && (
        <Button
          text='Clone'
          onClick={handleClone}
          color='secondary'
          loading={cloneLoading}
          disabled={!isSameData}
          tooltip={!isSameData ? 'You have unsaved changes, please save them as draft in order to clone.' : ''}
          style={!isSameData ? { pointerEvents: 'auto' } : {}}
        />
      )}
      {type === UPDATE_SURVEY && status === DRAFT && (
        <Button
          text='Publish'
          onClick={handlePublishClick}
          color='success'
          disabled={!isSameData}
          tooltip={!isSameData ? 'You have unsaved changes, please save them as draft in order to publish.' : ''}
          style={!isSameData ? { pointerEvents: 'auto' } : {}}
        />
      )}
      {status === CLOSED && (
        <Button
          text='Reopen'
          onClick={() => {
            setConfirmationType(REOPEN);
            setConfirmationPopupText('Are you sure you want to reopen this survey for submissions?');
          }}
          color='info'
        />
      )}
    </Box>
  );
});

Actions.displayName = 'Actions';

export default Actions;
